import { LeafletMouseEvent } from "leaflet";
import { useMapEvents } from "react-leaflet";
import { useMapPoint } from "../../hooks/mapHooks";

interface Props {}

export const MapClickHandler = (props: Props) => {
  const [, setPoint] = useMapPoint();

  useMapEvents({
    click: (event: LeafletMouseEvent) => {
      setPoint(event.latlng);
    },
  });

  return null;
};
